import {QuickbetsXAction, QuickbetsXActionTypes, QuickbetsXState} from "../../types/QuickbetX/quickbetXsTypes";

const initialState: QuickbetsXState = {
    quickbetsXData: [],
    quickbetsXDataLoading: false,
    quickbetsXDataError: null,
};

export const quickbetXsReducer = (state = initialState, action: QuickbetsXAction): QuickbetsXState => {
    switch (action.type) {
        case QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA:
            return { ...state, quickbetsXDataLoading: true, quickbetsXDataError: null, quickbetsXData: [] };
        case QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA_SUCCESS:
            return { ...state, quickbetsXDataLoading: false, quickbetsXDataError: null, quickbetsXData: action.payload };
        case QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA_ERROR:
            return { ...state, quickbetsXDataLoading: false, quickbetsXDataError: action.payload, quickbetsXData: [] };
        default:
            return state;
    }
};
